import "../../components/css/Plans.css";
import React from "react";
import {plansData} from "../../data/plansData";
import white from "../../assets/whiteTick.png";

const Plans = () => {
  return (
    <div className="plans-container">
         <div className="plan-2 blur"></div>
         <div className="plan-1 blur"></div>
      <div className="programheader">
        <span className="storkeb"> Ready to start</span>
        <span> Your Journy</span>
        <span className="storkeb"> Now with us</span>
      </div>

      {/* plansss */}

      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>{plan.price}</span>
            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="fetures">
                  <img src={white} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>
            <div>
                <span>See More Benifits-></span>
            </div>
            <div>
               <button className="raise-button with-shadow">
                See Plans
               </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
